import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IEventEnrollment } from '../eventEnrollments/store';
import { IPlayerEditorModalStore } from './store';

export interface IPlayerEditorModalActions extends IActionGroup {
  closeModal: () => { playerEditorModalStore?: IPlayerEditorModalStore; errors?: IErrorsStore };
  openModal: () => { playerEditorModalStore?: IPlayerEditorModalStore; errors?: IErrorsStore };
  selectEnrollment: (
    enrollment: IEventEnrollment
  ) => { playerEditorModalStore?: IPlayerEditorModalStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  closeModal: async (state: IStore) => {
    return {
      ...state,
      playerEditorModal: {
        enrollment: undefined,
        modalIsOpen: false
      }
    };
  },
  openModal: async (state: IStore) => {
    return {
      ...state,
      playerEditorModal: {
        ...state.playerEditorModal,
        modalIsOpen: true
      }
    };
  },
  selectEnrollment: async (state: IStore, enrollment: IEventEnrollment) => {
    return {
      ...state,
      playerEditorModal: {
        ...state.playerEditorModal,
        enrollment
      }
    };
  }
};

export default actions;
